import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './ReadOnlyInput.css';

class ReadOnlyInput extends Component {
  static propTypes = {
    class: PropTypes.string,
    placeholder: PropTypes.string,
    theme: PropTypes.oneOf(['bordered', 'normal', 'underlined']),
    value: PropTypes.string,
  };

  static defaultProps = {
    class: null,
    placeholder: '',
    theme: 'bordered',
    value: '',
  };

  render() {
    return (
      <div
        className={
          'readonly-input form-control input-area ' +
          this.props.theme +
          (this.props.class !== null ? ' ' + this.props.class : '')
        }
      >
        <div>{this.props.placeholder}</div>
        <div>{this.props.value}</div>
      </div>
    );
  }
}

export default ReadOnlyInput;



// WEBPACK FOOTER //
// ./src/components/shared/input/ReadOnlyInput.js